import { AuctionProposalLeadValueProps } from "@/features/maintenance/features/establishmentChoice/features/auctions/types/auctionProposalLeadValue.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { ComponentType } from "react";
import DiagnosticProposalLeadValue from "../components/AuctionProposal/DiagnosticProposalLeadValue";
import ExecutionProposalLeadValue from "../components/AuctionProposal/ExecutionProposalLeadValue";

/**
 * Lookup table: directive entry klass -> component that renders the highlighted
 * (lead) proposal value. Register a new klass here instead of branching in the
 * component; a klass without an entry simply renders no lead value.
 */
export const auctionProposalLeadValueByDirectiveEntryKlass: Partial<{
  [DirectiveEntry in MaintenanceForwardingsDirectiveEntryKlass]: ComponentType<AuctionProposalLeadValueProps>;
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: ExecutionProposalLeadValue,
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: DiagnosticProposalLeadValue,
};
